import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import {Inc,Owner,OwnerBank} from './Inc';
import ColInput from './ColInput';
import RowData from './RowData';
import Yesno from './Yesno';
import Ajax from './Ajax';
import Toast from './Toast';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import Title from './Title';
import Loading from './Loading';

interface Props {
	owner:Owner,
	managerId:number,
}

//let errors:string[] = [];

const BankInput = (props:Props)=> {
	Ajax.setEditorId( props.owner.owner_id );
	const classes = useStyles();
	const [states,setStates] = useState({
		bank: Inc.defaultOwnerBank(),
		ready: false,
		yesno: "",
		error: false,
		errorName: "",
		//errorCode: "",
		errors1: [] as string[],
		errors2: [] as string[],
		redirectId: 0,
		isLoading: true,
		toast: "",
	});
	const addError = (name:keyof OwnerBank,isError:boolean) =>{
		setStates(prev=>{
			if( prev.bank.bank_type_id===1 ){
				const errors1 = [...prev.errors1];
				if( isError ){
					if( !errors1.includes(name) ){
						errors1.push( name );
					}
				} else {
					if( errors1.includes(name) ){
						const index = errors1.findIndex((v) => v===name);
						errors1.splice(index,1);
					}
				}
				return {
					...prev,
					errors1: errors1,
					error: errors1.length>0,
				}
			} else {
				let errors2 = [...prev.errors2];
				if( isError ){
					if( !errors2.includes(name) ){
						errors2.push( name );
					}
				} else {
					if( errors2.includes(name) ){
						const index = errors2.findIndex((v) => v===name);
						errors2.splice(index,1);
					}
				}
                // console.log("errors2", errors2);
                // console.log("error", error);
				return {
					...prev,
					errors2: errors2,
					error: errors2.length>0,
				}
			}
		});
	}
	const change = (name:keyof OwnerBank,value:string)=>{
		if( name==="bank_type_id" ){
			// console.log("value",value);
            // console.log("errors1",states.errors1);
            // console.log("errors2",states.errors2);
			setStates(prev => ({
				...prev,
				bank: {
					...prev.bank,
					bank_type_id: parseInt(value),
				},
				error: ((value==="1" && prev.errors1.length>0) || (value==="2" && prev.errors2.length>0)) ? true : false,
			}));
		} else {
			setStates(prev => ({
				...prev,
				bank: { ...prev.bank, [name]: value }
			}));
		}
	}
	const changeNumber = (name:keyof OwnerBank,value:string)=>{
		setStates(prev=>({...prev,"bank":{...prev.bank,[name]:Tools.toNumber(value)}}));
	}
	const blur = ()=>{
		setStates(prev=>{
            let errorName = "";
            if( prev.bank.bank_name && prev.bank.bank_name.substr(0,4)==="ゆうちょ" ){
                errorName = "ゆうちょ銀行の場合は金融機関種類を「ゆうちょ」にして下さい";
            }
            return {
                ...prev,
                "errorName":errorName,
            };
        });
	}
	const confirm = ()=>{
		//console.log("states",states);
		//console.log("errors",errors);
		// let error = false;
		// if( errors.length>0 ){
		//	 error = true;
		// }
		// if( states.errorName!=="" || states.errorCode!=="" ){
		//	 error = true;
		// }
		if( states.error ){
			setStates(prev=>({...prev,toast:"入力の不完全な欄（赤字）があります。"}));
		} else {
			setStates(prev=>({...prev,yesno:"この内容で登録します。\nよろしいですか？"}));
		}
	}
	const closeToast = ()=>{
		setStates(prev=>({...prev,toast:""}));
	}
	const yes = ()=>{
		setStates(prev=>({...prev,isLoading:true}));
        let bank_code = "";
        if( states.bank.bank_type_id===1 && states.bank.bank_code1 ){
            bank_code = states.bank.bank_code1.replace(/--/g,"-");
        }
        if( states.bank.bank_type_id===2 && states.bank.bank_code2 ){
            bank_code = states.bank.bank_code2;
        }
		Ajax.send("bank/do",{
            bank:{
                ...states.bank,
                bank_code: bank_code,
                bank_signature: states.bank.bank_type_id===1 ? states.bank.bank_signature1 : states.bank.bank_signature2,
            }
        },(res:any)=>{
			//console.log(res);
			if( res.ok ){
				setStates(prev=>({...prev,redirectId:1,isLoading:false}));
			}
		});
	}
	const no = ()=>{
		setStates(prev=>({...prev,yesno:""}));
	}

	useEffect( ()=>{
		//console.log(props.owner);
		if( props.owner.owner_id>0 ){
			Ajax.send("bank/get",{manager_id:props.managerId},(res:any)=>{
				//console.log(res);
				if( res.ok ){
                    let errors1 = [] as string[];
                    let errors2 = [] as string[];
					let error = false;
                    const bank = Inc.convOwnerBank(res.bank);

					if( bank.bank_code==="" ){
                        errors1 = ["bank_code1","bank_signature1"];
                        errors2 = ["bank_code2","bank_signature2","bank_name","bank_store"];
						error = true;
                    } else if( bank.bank_type_id===1 ){
                        errors2 = ["bank_code2","bank_signature2","bank_name","bank_store"];
                    } else {
                        errors1 = ["bank_code1","bank_signature1"];
                    }
                    // bank.bank_code1に-が1つだけ含まれる場合は、その-を--に置換する
                    if( bank.bank_code1 && bank.bank_code1.includes("-") && bank.bank_code1.split("-").length===2 ){
                        bank.bank_code1 = bank.bank_code1.replace(/-/,"--");
                    }

					// console.log("bank_type_id",res.bank.bank_type_id);
					// console.log("errors1", errors1);
					// console.log("errors2", errors2);

					setStates(prev=>({
						...prev,
						"isLoading":false,
						"bank":bank,
						"errors1":errors1,
						"errors2":errors2,
						"error": error,
					}))
				}
			});
		} else {
			setStates(prev=>({
				...prev,
				"bank":Inc.defaultOwnerBank(),
				"errors1":[],
				"errors2":[],
				"isLoading":false,
			}));
		}
	} ,[]);

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		)
	}

	if( states.redirectId>0 || props.owner.switch_id>1 ){
		return (
			<Redirect to="/bank"/>
		)
	}


	// let code1 = "";
	// let code2 = "";
	// let code3 = "";
	// if( states.bank.bank_code && states.bank.bank_code!=="" && states.bank.bank_type_id===1 ){
	// 	const sp = states.bank.bank_code.split("-");
	// 	if( sp.length===2 ){
	// 		code1 = sp[0];
	// 		code3 = sp[1];
	// 	}
	// 	if( sp.length===3 ){
	// 		code1 = sp[0];
	// 		code2 = sp[1];
	// 		code3 = sp[2];
	// 	}
	// }

	return (
		<div id="bank_input" className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={9}>
					<Paper className={classes.paper}>
						<Title text="支払口座" icon="portrait"/>
						<div style={{marginBottom:"2em"}}>
						商品の売上を受け取る口座情報を入力して下さい。<br/>
						</div>
						<Hidden mdUp implementation="js">
							<BottomButtons button1='この内容で登録する' onClick1={confirm} disabled1={states.error} button2='登録しないで中断する' link2='/bank'/>
						</Hidden>

						<Grid container spacing={2}>
							<Grid item xs={12}>
								<ColInput name="金融機関種類" value={String(states.bank.bank_type_id)} addError={addError} change={change} id="bank_type_id" type="radio" list={Inc.bankTypes} required/>
							</Grid>
							{states.bank.bank_type_id===1 ? (
							<React.Fragment>
								<Grid item xs={12}>
									<ColInput
										name="口座番号"
										value={states.bank.bank_code1 || ""}
										addError={addError}
										change={change}
										id="bank_code1"
										type="segment"
										segment={{
											width:"100%",
											maxWidth:"400px",
											placeholder:["記号","","番号"],
											required:[true,false,true],
											widths:["25%","15%","30%"],
                                            maxLengths:[5,1,8],
										}}
										helper="記号と番号の間に1桁の数字がない場合は、真ん中の入力欄は空欄にしてください"
										required/>
								</Grid>
								<Grid item xs={12}>
									<ColInput name="口座名義" value={states.bank.bank_signature1 || ""} addError={addError} change={change} maxLength={30} id="bank_signature1" helper="全角カタカナで姓と名の間にスペースを" type="text" required/>
								</Grid>
							</React.Fragment>
							):(
							<React.Fragment>
								<Grid item xs={6}>
									<ColInput name="金融機関名" error={states.errorName || ""} blur={blur} value={states.bank.bank_name || ""} addError={addError} change={change} maxLength={30} id="bank_name" type="text" required/>
								</Grid>
								<Grid item xs={6}>
									<ColInput name="支店名" value={states.bank.bank_store || ""} addError={addError} change={change} maxLength={30} id="bank_store" type="text" required/>
								</Grid>
								<Grid item xs={12}>
									<ColInput name="口座種目" value={states.bank.bank_cat_id ? String(states.bank.bank_cat_id) : "1"} addError={addError} change={change} id="bank_cat_id" type="radio" list={Inc.bankCats} required/>
								</Grid>
								<Grid item xs={6}>
									<ColInput name="口座番号" value={states.bank.bank_code2 || ""} addError={addError} change={changeNumber} maxLength={7} id="bank_code2" type="text" required/>
								</Grid>
								<Grid item xs={6}>
									<ColInput name="口座名義" value={states.bank.bank_signature2 || ""} addError={addError} change={change} maxLength={30} id="bank_signature2" type="text" helper="全角カタカナで姓と名の間にスペースを" required/>
								</Grid>
							</React.Fragment>
							)}
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} md={3}>
					<Paper className={classes.paper}>
						<Title text="管理情報" size={2}/>
						<RowData name="作家名" value={props.owner.owner_name}/>
						<RowData name="会員名" value={props.owner.customer.name}/>
						<Divider style={{margin:"1em 0"}}/>
						<div>
							<div style={{color:'#666666'}}>メールアドレス</div>
							<div className={classes.yourMail}>{props.owner.customer.mail}</div>
						</div>
						<Hidden mdDown implementation="js">
							<Divider style={{margin:"1em 0"}}/>
							<Grid container spacing={1}>
								<Grid item xs={12} lg={12}>
									<Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.error}>この内容で登録する</Button>
								</Grid>
								<Grid item xs={12} lg={12}>
									<Link to="/bank"><Button variant="outlined" style={{width:"100%"}}>登録しないで中断する</Button></Link>
								</Grid>
							</Grid>
						</Hidden>
					</Paper>
				</Grid>
			</Grid>
			<Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Toast close={closeToast} mes={states.toast}/>
		</div>
	);
}

export default BankInput;
